import { render, staticRenderFns } from "./ModalSave.vue?vue&type=template&id=105c7226&scoped=true&"
import script from "./ModalSave.vue?vue&type=script&lang=js&"
export * from "./ModalSave.vue?vue&type=script&lang=js&"
import style0 from "./ModalSave.vue?vue&type=style&index=0&id=105c7226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c7226",
  null
  
)

export default component.exports